/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React from "react";
import notFound_img from "../../Images/error.jpg";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto ">
        <div className="flex justify-center items-center my-12 mt-20">
          <div className="w-[350px] md:w-[500px] h-[400px] rounded-md">
            <img src={notFound_img} alt="" className="w-full h-full" />
          </div>
        </div>
        <div className="flex justify-center items-center my-6">
          <Link to="/">
            <div className="w-[200px] p-2 bg-[#007DfE] hover:bg-navBg rounded-xl">
              <button className="w-full text-white font-semibold">
                Back to Home
              </button>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
